import { commitMutation } from "relay-runtime"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import { Ch_createProgressNoteInput } from "@/modules/patients/services/ch/__generated__/chCreateProgressNoteMutation.graphql"
import { chCreateProgressNoteMutation } from "@/modules/patients/services/ch/chCreateProgressNoteMutation"
import { De_createProgressNoteInput } from "@/modules/patients/services/de/__generated__/deCreateProgressNoteMutation.graphql"
import { deCreateProgressNoteMutation } from "@/modules/patients/services/de/deCreateProgressNoteMutation"
import { RelayEnvironment } from "@/relay-environment"

const de_CreateProgressNote = (input: De_createProgressNoteInput, addConnections: string[], onCompleted?: () => void) =>
  commitMutation(RelayEnvironment, {
    mutation: deCreateProgressNoteMutation,
    variables: {
      input,
      addConnections,
    },
    onCompleted,
  })

const ch_CreateProgressNote = (input: Ch_createProgressNoteInput, addConnections: string[], onCompleted?: () => void) =>
  commitMutation(RelayEnvironment, {
    mutation: chCreateProgressNoteMutation,
    variables: {
      input,
      addConnections,
    },
    onCompleted,
  })

export const createProgressNote = (
  country: Country,
  input: De_createProgressNoteInput & Ch_createProgressNoteInput,
  addConnections: string[],
  onCompleted?: () => void,
) => {
  if (country === "DE") {
    return de_CreateProgressNote(input, addConnections, onCompleted)
  }
  return ch_CreateProgressNote(input, addConnections, onCompleted)
}
